import { Children, type FC, type ReactNode } from "react";
import MyAccountRegistered from "~/features/myAccount/profile/components/MyAccountRegistered/MyAccountRegistered";
import { userIsLoggedIn, userIsRegistered } from "~/domains/user/utils/roles";
import MyAccountB2B from "~/features/myAccount/profile/components/MyAccountB2B/MyAccountB2B";
import { type MyAccountDataJSP } from "~/features/myAccount/profile/myAccountTypes";
import { transformMyAccountData } from "~/features/myAccount/profile/myAccountDataTransformers";
import classNames from "classnames";

export function createMyAccountPage(data: MyAccountDataJSP) {
  return <MyAccountContainer {...data} />;
}

export const MyAccountContainer = (dataDto: MyAccountDataJSP) => {
  const loggedIn = userIsLoggedIn();
  const registeredUser = userIsRegistered();

  const data = transformMyAccountData(dataDto);

  return <>{loggedIn && <>{registeredUser ? <MyAccountRegistered data={data} /> : <MyAccountB2B data={data} />}</>}</>;
};

interface FormSectionProps extends Omit<JSX.IntrinsicElements["div"], "title"> {
  title?: ReactNode;
  className?: string;
  children?: ReactNode;
}

export const FormSection: FC<FormSectionProps> = ({ children, title, className, ...rest }) => {
  return (
    <div className={classNames("scha__my-account-form__section", className)} {...rest}>
      {title && <h3 className={"scha__my-account-form__section__title"}>{title}</h3>}
      {Children.map(children, (child) => child && <div className="scha__my-account-form__field">{child}</div>)}
    </div>
  );
};
